import React from 'react';

var isChildType = function isChildType(child, type) {
  return /*#__PURE__*/React.isValidElement(child) && child.type === type;
};

export default isChildType;